<template>
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{ $t('Device Owner') }}</label>
          <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="ownerFilter"
              :options="ownersOptions"
              class="w-100"
              :reduce="val => val.id"
              label="name"
              @input="(val) => $emit('update:ownerFilter', val)"
          />
        </b-col>

        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{$t('Device Contract')}}</label>
          <v-select
          :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
              :value="contractFilter"
              :options="contractOptions"
              class="w-100"
              :reduce="val => val.id"
              label="name"
              @input="(val) => $emit('update:contractFilter', val)"
          />
        </b-col>

        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{$t('Device Group')}}</label>
          <v-select
          :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
              :value="groupFilter"
              :options="groupsOptions"
              class="w-100"
              label="name"
              :reduce="val => val.id"
              @input="(val) => $emit('update:groupFilter', val)"
          />
        </b-col>



        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{$t('Device Type')}}</label>
          <v-select
          :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
              :value="typeFilter"
              :options="typesOptions"
              class="w-100"
              :reduce="val => val.id"
              label="name"
              @input="(val) => $emit('update:typeFilter', val)"
          />
        </b-col>



        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{$t('Device Category')}}</label>
          <v-select
          :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
              :value="categoryFilter"

              :options="categoriesOptions.map(i=>({id:i,name:$t(i)}))"
              :getOptionLabel="c => c.name"
              :reduce="val => val.id"
              class="w-100"
              @input="(val) => $emit('update:categoryFilter', val)"
          />
        </b-col>

      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  props: {

    contractFilter: {
      type: [Number, null],
      default: null,
    },

    typeFilter: {
      type: [Number, null],
      default: null,
    },

    groupFilter: {
      type: [Number, null],
      default: null,
    },

    ownerFilter: {
      type: [Number, null],
      default: null,
    },

    categoryFilter: {
      type: [String, null],
      default: null,
    },

    contractOptions: {
      type: Array,
      required: true,
    },

    groupsOptions: {
      type: Array,
      required: true,
    },

    ownersOptions: {
      type: Array,
      required: true,
    },

    typesOptions: {
      type: Array,
      required: true,
    },

    categoriesOptions: {
      type: Array,
      required: true
    }
  },
}
</script>

<style scoped>

</style>
